import type { MouseEvent } from "react";

export type AvatarButtonProps = {
  label: string;
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  size?: number;
};

export const AvatarButton = ({
  label,
  onClick,
  className = "",
  size = 40,
}: AvatarButtonProps): JSX.Element => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`flex items-center justify-center rounded-full bg-neutral-medium2 text-neutral-darkest text-sm font-semibold focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-light transition-colors hover:bg-neutral-mediumDark hover:text-white ${className}`}
      style={{ width: size, height: size }}
    >
      {label}
    </button>
  );
};
